import styled from 'styled-components';

export const StyledAds = styled.div`
  margin-top: 40px;

  section {
    padding: 0 40px;

    h2 {
      font-family: Poppins-Medium, Heltica, Arial, sans-serif;
      font-size: 15px;
      color: #2B2932;
      margin: 0 0 10px 0;
    }
    
    p {
      font-family: Poppins, Heltica, Arial, sans-serif;
      font-size: 13px;
      line-height: 1.5em;
      color: #2B2932;
    }
  }

  hr {
    border-color: #F5F7F9;
  }
`;
